// utils/axiosUtil.js
import { baseInstance } from "@/config/instance";
import logger from "./loggerUtil";

export const onParseResponse = async (args) => {
  let formattedResponse;

  try {
    if (!args || !args.method || !args.url) {
      throw new Error("Missing required request parameters");
    }

    const response = await baseInstance({ ...args });

    // Check if response is binary (PDF)
    if (args.responseType === "arraybuffer") {
      // Return the binary data directly
      return response.data;
    }

    // For regular JSON responses
    formattedResponse = response.data;
  } catch (error) {
    logger("API Error:", error);
    if (error.response?.data) {
      // For binary responses, check content type
      if (args.responseType === "arraybuffer") {
        // If it's a binary error response, try to parse it as JSON
        const errorText = new TextDecoder().decode(error.response.data);
        try {
          formattedResponse = JSON.parse(errorText);
        } catch {
          formattedResponse = {
            success: false,
            message: "Failed to generate PDF",
          };
        }
      } else {
        formattedResponse = error.response.data;
      }
    } else {
      throw error;
    }
  }

  return formattedResponse;
};
